import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestSingleChoiceDemo from './TestSingleChoiceDemo'
import TestSingleChoiceEditorActions from './TestSingleChoiceEditorActions'
import TestSingleChoiceElement from './TestSingleChoiceElement'
import TestSingleChoiceFormBrand from './TestSingleChoiceFormBrand'
import { TEST_SINGLE_CHOICE_STYLE_FIELDS } from './TestSingleChoiceFormStyle'
import TestSingleChoiceFormValue from './TestSingleChoiceFormValue'
import radioIcon from './assets/test-single-choise.svg'

export default genElementConfig(CONFIG_ELEMENTS.testSingleChoice, {
  label: t('elements.testSingleChoice.label'),
  icon: radioIcon,
  group: ElementGroup.test,
  styleFields: TEST_SINGLE_CHOICE_STYLE_FIELDS,
  Element: TestSingleChoiceElement,
  Demo: [TestSingleChoiceDemo],
  FormBrand: TestSingleChoiceFormBrand,
  FormValue: TestSingleChoiceFormValue,
  EditorActions: TestSingleChoiceEditorActions,
})
